import {
  OverlayArrow,
  Tooltip as AriaTooltip
} from 'react-aria-components';

export function AriaTooltipStyled({ children, placement, ...props }) {
  // Determine arrow rotation based on placement
  const getArrowRotation = () => {
    switch(placement) {
      case 'right': return 'rotate(90deg)';
      case 'left': return 'rotate(-90deg)';
      case 'bottom': return 'rotate(180deg)';
      case 'top': 
      default: return 'rotate(0deg)';
    }
  };

  return (
    <AriaTooltip 
      {...props}
      placement={placement}
      className="bg-blue-100 text-blue-900 text-xs px-2 py-1 rounded border border-blue-300 shadow-sm max-w-[150px] z-50"
      offset={12}
    >
      <OverlayArrow>
        <svg 
          width={8} 
          height={8} 
          viewBox="0 0 8 8" 
          className="fill-blue-100 stroke-blue-300"
          style={{ transform: getArrowRotation() }}
        >
          <path d="M0 0 L4 4 L8 0" />
        </svg>
      </OverlayArrow>
      {children}
    </AriaTooltip>
  );
}
